import styled from 'foundations-theming/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { getDocumentsUrl, getMeetingsUrl } from 'hubspot-prosemirror/draft-transplant/utils/links';
import { H7 } from 'UIComponents/elements/headings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Divider = styled.div.withConfig({
  displayName: "InlineInsertHeader__Divider",
  componentId: "sc-1pxqi5-0"
})(["background-color:", ";height:24px;margin-right:12px;width:1px;"], ({
  theme
}) => theme.color['do-not-use-battleship']);
const MediaHeader = styled.div.withConfig({
  displayName: "InlineInsertHeader__MediaHeader",
  componentId: "sc-1pxqi5-1"
})(["align-items:center;display:flex;justify-content:space-between;width:100%;"]);
const MANAGE_URL_MAP = {
  MEETINGS: getMeetingsUrl(),
  DOCUMENTS: getDocumentsUrl()
};
const getHeaderText = type => {
  if (type === 'MEETINGS') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubspot-prosemirror.insertHeader.insertItem.MEETINGS"
    });
  }
  if (type === 'DOCUMENTS') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubspot-prosemirror.insertHeader.insertItem.DOCUMENTS"
    });
  }
  return null;
};
const InlineInsertHeader = props => {
  const {
    onBackClick,
    onClickManageButton,
    selectedType
  } = props;
  if (!selectedType) {
    return null;
  }
  const manageUrl = MANAGE_URL_MAP[selectedType];
  return /*#__PURE__*/_jsxs("div", {
    className: "display-flex align-center m-x-5 m-top-5",
    children: [/*#__PURE__*/_jsx(UIIconButton, {
      onClick: onBackClick,
      use: "link",
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "left"
      })
    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(MediaHeader, {
      children: [/*#__PURE__*/_jsx(H7, {
        className: "m-bottom-0",
        children: getHeaderText(selectedType)
      }), /*#__PURE__*/_jsx(UIButton, {
        external: true,
        href: manageUrl,
        size: "extra-small",
        use: "tertiary-light",
        onClick: onClickManageButton,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.insertHeader.manageContentLink"
        })
      })]
    })]
  });
};
export default InlineInsertHeader;